import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

export interface EntityDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmLeave: () => void;
}

export function ConfirmLeaveModal({
  isOpen,
  onClose,
  onConfirmLeave,
}: EntityDeleteModalProps): JSX.Element {
  const { t } = useTranslation('common');
  return (
    <Modal contentLabel={t('confirm-leave-modal.title')} isOpen={isOpen} onClose={onClose}>
      <Modal.Header title={t('confirm-leave-modal.title')} />
      <Modal.Body>{t('confirm-leave-modal.body')}</Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose}>
          {t('confirm-leave-modal.cancel')}
        </Button>
        <Button kind="danger" onClick={onConfirmLeave}>
          {t('confirm-leave-modal.confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
